/* eslint-disable no-template-curly-in-string */
import { array, number, object, string } from 'yup';
import { translateAndCastToString } from '../../../../utils';

export const productValidationSchema = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
    priceSell: number()
        .required('Required'),
    taxId: string()
        .required(),
    categoryId: string()
        .required(),
    recipeLines: array()
        .of(object(
            {
                stockCardId: string()
                    .required(translateAndCastToString('Stock card name can not be empty')),
                warehouseId: string()
                    .required(translateAndCastToString('Warehouse for stock card deduction is required')),
                quantity: number()
                    .moreThan(0, translateAndCastToString('Quantity must be greater than 0'))
                    .test(
                        'decimalPlaces',
                        translateAndCastToString('Must have 3 digits after decimal or less'),
                        num => num ? /^\d+(\.\d{1,3})?$/.test(num.toString()) : true,
                    )
                    .required(translateAndCastToString('Quantity is required')),
                unitType: string()
                    .required(translateAndCastToString('Unit type should be chosen')),
            }
        ).required())
        .min(0)
});
